import React from 'react'

const AdvantagesSection = ({ additionalClass = '', advantages, images = null, t }) => (
    <div className={`advantages-section ${additionalClass}`}>
        <h3>{t(advantages.header)}</h3>
        <ul>
            {advantages.items.map((advantage, ind) => {
                return (
                    <li key={ind}>
                        <div className="advantages-section__head">
                            <div className="advantages-section__head-img">
                                <img src={images[ind]} alt="" />
                            </div>
                            <p>{t(advantage.title)}</p>
                        </div>
                        <div className="advantages-section__text">{t(advantage.description)}</div>
                    </li>
                )
            })}
        </ul>
    </div>
)

export default AdvantagesSection
